import { ItnlIntegrationStyle } from "@/data/types/ItnlIntegrationStyle";

export const loadExternalStyles = (styles: ItnlIntegrationStyle[]) => {
    for (let style of styles) {
        let existingStyle: HTMLStyleElement | null = null;
        if (style.skipIfExists) {
            existingStyle = document.getElementById(style.id) as HTMLStyleElement;
        }
        if (existingStyle === null) {
            const styleElem = document.createElement('style');
            if (style.styleContent) {
               styleElem.append(style.styleContent);
            }
            document.body.appendChild(styleElem);
        }
    }
}
